export default __webpack_public_path__ + "static/POMORSKIE-kolor-RGB-d18c33bf3b41b8b07144f9191a444c6d.png";